module.exports = __webpack_public_path__ + "static/media/Promos_EnviosGratis.79dfaabf.png";